/**
 * ex.
 * デフォルトラベル
 * <base-label text="ラベル"></base-label>
 * <base-label text="ラベル" type="primary" on-click="addFunction()"></base-label>
 */
angular.module('inspinia').directive('baseLabel', () => {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      text: '@',
      type: '@',
      size: '@',
      onClick: '&',
      labelClasses: '&',
    },
    templateUrl: `/manage/src/view/directive/base_label.html?${new Date().getTime()}`,
    link($scope) {
      const labelSize = ['s', 'r', 'l'];
      $scope.size = $scope.size || 'r';
      if (labelSize.indexOf($scope.size) === -1) {
        throw new Error('button size is s,r,l');
      }

      const labelType = ['default', 'primary', 'alert', 'warning', 'disabled', 'success'];
      $scope.type = $scope.type || 'default';
      if (labelType.indexOf($scope.type) === -1) {
        throw new Error(`label type is ${labelType.join(',')}`);
      }
      if (!$scope.text) {
        throw new Error('label text is required');
      }

      $scope.onClickBaseLabel = () => {
        $scope.onClick();
      };

      $scope.labelClasses = () => {
        const labelClasses = {};
        labelClasses[`anglrC-label`] = true;
        if ($scope.type) {
          labelClasses[`anglrC-label--${$scope.type}`] = true;
        }
        return labelClasses;
      };
    },
  };
});
